<template>
	<div class="keyboard">
		<section class="hander-cls">
			<span>按键</span>
		</section>
		<section class="input-cls">
			<el-input v-model="value" clearable></el-input>
		</section>

		<section class="key-cls">
			<div @click.stop="handleKeyboard(item)" class="cell" v-for="(item, index) in ['1','2','3','4','5','6','7','8','9','*','0','#']" :key="index">{{item}}</div>
		</section>
	</div>
</template>

<script>
export default {
	props: ['sipDriver'],
	data() {
		return {
			value: '',
			cdnUrl: process.env.VUE_APP_BASE_CDN
		}
	},
	methods: {
		handleKeyboard(key) {
			this.value = this.value+key;
			if (key == "*") {
				window.media = new Audio(`${this.cdnUrl}/static/media/asterisk.ogg`);
				media.play();
			} else if (key == "#") {
				window.media = new Audio(`${this.cdnUrl}/static/media/pound.ogg`);
				media.play();
			} else {
				window.media = new Audio(`${this.cdnUrl}/static/media/` + key + ".ogg");
				media.play();
			}
			this.sipDriver._sendDTMF(key);
		}
	}
}
</script>

<style lang="scss" scoped>
.keyboard {
	width: 240px;
	border: solid 1px #e3e3e3;
	border-radius: 4px;
	overflow: hidden;

	& > .hander-cls {
		width: 100%px;
		height: 40px;
		background: #f0f7fe;
		font-size: 18px;
		color: #586b82;
		font-weight: bold;
		line-height: 40px;
	}

	& > .input-cls {
		width: 100%;
		padding: 10px 8px;
		box-sizing: border-box;

		::v-deep .el-input {
			height: 40px;
		}
	}

	& > .key-cls {
		& > .cell {
			width: calc((100% - 60px) / 3);
			height: 60px;
			float: left;
			margin: 0 10px 10px;
			font-weight: bold;
			font-size: 30px;
			text-align: center;
			line-height: 60px;
			cursor: pointer;
			border-radius: 50%;
			color: #566980;

			&:hover {
				background: #f3f7fe;
				color: #347dff;
			}
		}
	}
}
</style>